// FILE: frontend/src/components/CompleteView.jsx
// Session completion summary with stats cards (Patricia's design)

import React from 'react'

export default function CompleteView({
  mode,
  goals,
  scores,
  testScores,
  placedLevel,
  serverExchanges,
  transcript,
  onPracticeAgain,
  onReviewScores,
  onLogout,
}) {
  const showPractice = mode === 'practice'
  const showTest = mode === 'test'

  const avgScore = scores.length > 0
    ? (scores.reduce((s, x) => s + Number(x.overall || 0), 0) / scores.length).toFixed(1)
    : '0.0'

  const avgTestScore = testScores.length > 0
    ? (testScores.reduce((s, x) => s + Number(x.overall || 0), 0) / testScores.length).toFixed(1)
    : '0.0'

  const exchanges = serverExchanges ?? (transcript ? transcript.filter(m => m.speaker === 'user').length : 0)

  return (
    <div className="sqa-complete">
      <h1>Great Job! 🎉</h1>
      <p>{showTest ? "You've completed the placement test!" : "You've completed the lesson!"}</p>

      {showPractice && (
        <div className="sqa-stats">
          <div className="sqa-stat-card">
            <div className="sqa-stat-value">{goals.completed}/{goals.total}</div>
            <div className="sqa-stat-label">Goals Completed</div>
          </div>
          <div className="sqa-stat-card">
            <div className="sqa-stat-value">{avgScore}</div>
            <div className="sqa-stat-label">Average Score</div>
          </div>
          <div className="sqa-stat-card">
            <div className="sqa-stat-value">{exchanges}</div>
            <div className="sqa-stat-label">Exchanges</div>
          </div>
        </div>
      )}

      {showTest && (
        <div className="sqa-stats">
          <div className="sqa-stat-card">
            <div className="sqa-stat-value">{placedLevel || '—'}</div>
            <div className="sqa-stat-label">Placed Level</div>
          </div>
          <div className="sqa-stat-card">
            <div className="sqa-stat-value">{testScores.length}</div>
            <div className="sqa-stat-label">Questions</div>
          </div>
          <div className="sqa-stat-card">
            <div className="sqa-stat-value">{avgTestScore}</div>
            <div className="sqa-stat-label">Avg Score</div>
          </div>
        </div>
      )}

      <div className="sqa-actions">
        <button className="sqa-btn sqa-btn-primary" onClick={onPracticeAgain}>
          {mode === 'test' ? 'Take Again' : 'Practice Again'}
        </button>
        {showPractice && (
          <button className="sqa-btn sqa-btn-secondary" onClick={onReviewScores}>
            Review Scores
          </button>
        )}
        <button className="sqa-btn sqa-btn-secondary" onClick={onLogout}>
          Logout
        </button>
      </div>
    </div>
  )
}
